// extracted by mini-css-extract-plugin
export default {"root":"SettingsItemSubtitle_root__5w27o","subtitle":"SettingsItemSubtitle_subtitle__j1tli"};